module.exports = __webpack_public_path__ + "static/media/solar-system.2f6bf6a4.svg";